import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

import { getCurrencySymbol } from '@/constants/countries';
import { RootState } from '@/redux/store';

interface PairTitleProps {
  title: string;
  value?: string;
  isBold?: boolean;
  iconTitle?: React.ReactNode;
  iconValue?: React.ReactNode;
  isPrice?: boolean;
  isGreen?: boolean;
  children?: React.ReactNode;
  icon?: React.ReactNode;
}

const PairTitle = ({ title, value, isBold, isPrice, children, isGreen, icon }: PairTitleProps) => {
  const theme = useTheme();
  const { profile } = useSelector((state: RootState) => state.parcel);
  const currencySymbol = getCurrencySymbol(profile.data?.country);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
      <Box display="flex" alignItems="center" sx={{ margin: '0 auto' }}>
        <Typography
          component="span"
          variant={isBold ? 'subtitle1' : 'body1'}
          fontWeight={theme.typography.fontWeightMedium}
          sx={{
            color: isGreen ? theme.palette.primary.main : 'inherit',
            display: 'flex',
            gap: '0.5rem',
            alignItems: 'center',
          }}
        >
          {title} {icon ? icon : ''}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" sx={{ margin: '0 auto' }}>
        {children}
        {isPrice ? (
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
            {currencySymbol} {value}
          </Typography>
        ) : (
          <Typography
            component="span"
            variant="body1"
            sx={{
              fontWeight: isBold ? 'bold' : 'normal',
              whiteSpace: 'normal',
              wordBreak: 'break-all',
              color: theme.palette.grey[800],
              textAlign: 'center',
            }}
          >
            {value}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default PairTitle;
